'use es6';

import { useState, useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { getReport } from '../api/reportsApi';
import { useParams } from 'react-router-dom';
import GenericSplashMessage from 'dashboard-components/email/GenericSplashMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import EmailReport from '../components/email/EmailReport';
import { jsx as _jsx } from "react/jsx-runtime";
const EmailReportPreviewContainer = () => {
  const {
    reportId
  } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [report, setReport] = useState({});
  useEffect(() => {
    getReport(reportId).then(reportResponse => {
      setReport(reportResponse);
      setIsLoading(false);
    }).catch(() => {
      setIsError(true);
    });
  }, [reportId]);
  const renderEmailReport = () => {
    if (isError) {
      return /*#__PURE__*/_jsx(GenericSplashMessage, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reports.emailReportPreview.reportErrorTitle"
        })
      });
    } else if (isLoading) {
      return /*#__PURE__*/_jsx(LoadingSpinner, {
        layout: "centered"
      });
    }
    return (
      /*#__PURE__*/
      // required id for BE screen capture
      _jsx("div", {
        id: "report-email-container",
        children: /*#__PURE__*/_jsx(EmailReport, {
          overriddenReport: report
        })
      })
    );
  };
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "EXPORT_REPORT_PREVIEW_PAGE_LOADED",
    children: renderEmailReport()
  });
};
export default EmailReportPreviewContainer;